import { SidebarProvider as RadixSidebarProvider } from '@/components/ui/sidebar'
import { ReactNode } from 'react'

interface SidebarProviderProps {
  children: ReactNode
}

export function SidebarProvider({ children }: SidebarProviderProps) {
  return (
    <RadixSidebarProvider defaultOpen={true}>
      {children}
    </RadixSidebarProvider>
  )
} 